<div class="rt-fade" *ngIf="confirmBar.status">

  <div class="modal-card">
    <div class="modal-body">
      <h2>{{confirmBar.label}}</h2>
      <h4>{{confirmBar.label2}}</h4>
    </div>

    <div class="rt-modal-footer mt-2">
      <button class="rt-btn" (click)='emitEvent("back")'>{{confirmBar.cancelLabel}}</button>
      <button class="rt-btn" (click)='emitEvent("one")' *ngIf="confirmBar.proceedLabel">{{confirmBar.proceedLabel}}</button>
      <button class="rt-btn" *ngIf="confirmBar.proceedLabel2"
        (click)='emitEvent("two")'>{{confirmBar.proceedLabel2}}</button>
    </div>
  </div>
</div>